import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { Accordion, Card, Container } from 'react-bootstrap';
import useStyles from 'isomorphic-style-loader/useStyles';
import s from './Faq.css';
import useScrollReveal from '../../hooks/useScrollReveal';
import messages from '../../../../locale/messages';

const faqs = [
  {
    id: 'deliveryTime',
    q: messages.homeFaqQuestionOne,
    a: messages.homeFaqAnswerOne,
  },
  {
    id: 'trackOrder',
    q: messages.homeFaqQuestionTwo,
    a: messages.homeFaqAnswerTwo,
  },
  {
    id: 'serviceArea',
    q: messages.homeFaqQuestionThree,
    a: messages.homeFaqAnswerThree,
  },
  {
    id: 'paymentMethods',
    q: messages.homeFaqQuestionFour,
    a: messages.homeFaqAnswerFour,
  },
  {
    id: 'wrongOrLateOrder',
    q: messages.homeFaqQuestionFive,
    a: messages.homeFaqAnswerFive,
  },
];

function Faq() {
  useStyles(s);
  const [activeKey, setActiveKey] = useState(null);
  const { ref, isVisible } = useScrollReveal();

  const handleSelect = key => {
    setActiveKey(activeKey === key ? null : key);
  };

  return (
    <section id="faq" className={s.faq} ref={ref}>
      <Container style={{ maxWidth: '780px' }}>
        <div className={`text-center ${s.header} ${isVisible ? s.headerVisible : ''}`}>
          <span className={s.badge}>FAQ</span>
          <h2 className={s.heading}>
            <FormattedMessage {...messages.homeFaqHeading} />
          </h2>
          <p className={`${s.sub} mx-auto`}>
            <FormattedMessage {...messages.homeFaqSub} />
          </p>
        </div>

        <Accordion activeKey={activeKey} onSelect={handleSelect}>
          {faqs.map((item, i) => {
            const key = String(i);
            const isOpen = activeKey === key;
            return (
              <Card
                key={item.id}
                className={`${s.item} ${isOpen ? s.itemOpen : ''} ${isVisible ? s.itemVisible : ''}`}
                style={{ transitionDelay: isVisible ? `${0.1 + i * 0.08}s` : '0s' }}
              >
                <Accordion.Toggle
                  as="div"
                  eventKey={key}
                  className={s.summary}
                >
                  <span className={`${s.num} ${isOpen ? s.numOpen : ''}`}>
                    {String(i + 1).padStart(2, '0')}
                  </span>
                  <span className={`${s.question} ${isOpen ? s.questionOpen : ''}`}>
                    <FormattedMessage {...item.q} />
                  </span>
                  <span
                    className={`${s.toggle} ${isOpen ? s.toggleOpen : ''}`}
                    aria-hidden="true"
                  >
                    {isOpen ? '×' : '+'}
                  </span>
                </Accordion.Toggle>
                <Accordion.Collapse eventKey={key}>
                  <Card.Body className={s.body}>
                    <p className={s.answer}>
                      <FormattedMessage {...item.a} />
                    </p>
                  </Card.Body>
                </Accordion.Collapse>
              </Card>
            );
          })}
        </Accordion>
      </Container>
    </section>
  );
}

export default Faq;
